import Vue from 'vue'
import Vuex from 'vuex';
import router from './router';
import Api from './services/Api'
Vue.use(Vuex)

const getDefaultState = () => {
  return {
    user: {
      username: '',
      first_name: '',
      last_name: '',
      email: '',
      company: '',
      admin: {}
    },
    loggedInStatus: false,
    roles: {},
    permissions: {},
    language: 'de',
    token: '',
    companies: [],
    navTree: [],
    routeData: [],
    activePage: {},
    sidebarOpen: false,
    components: [{name: 'Table', template: '../components/Table'}, {name: 'Filters', template: '../components/Filters'}]
  }
}
const store = new Vuex.Store({
  state: getDefaultState(),
  getters: {
    permissions: state => {
      return state.permissions
    },
    sidebarOpen: state => {
      return state.sidebarOpen
    },
    user: state => {
      return state.user
    },
    language: state => {
      return state.language
    },
    roles: state => {
      return state.roles
    },
    token: state => {
      return state.token
    },
    loggedInStatus: state => {
      return state.loggedInStatus
    },
    companies: state => {
      return state.companies
    },
    navTree: state => {
      return state.navTree
    },
    activePage: state => {
      return state.activePage
    },
    routeData: state => {
      return state.routeData
    }
  },
  mutations: {
    initialiseStore (state) {
      if (localStorage.getItem('store')) {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem('store')))
        )
      }
    },
    updateRouteData (state, routes) {
      state.routeData = routes
    },
    updateUser (state, user) {
      if (typeof state.user === 'string') {
        state.user = JSON.parse(state.user)
      }
      for (let x in user) {
        state.user[x] = user[x]
      }
    },
    toggleSidebar (state) {
      state.sidebarOpen = !state.sidebarOpen
    },
    updateRoles (state, roles) {
      Object.keys(state.roles).forEach(sr => {
        state.roles[sr] = false
      })
      Object.keys(roles).forEach(r => {
        state.roles[r] = roles[r]
      })
    },
    updateUserAdmin (state, admin) {
      state.user['admin'] = admin
    },
    updateCompanies (state, companies) {
      state.companies = companies
    },
    updateToken (state, token) {
      state.token = token
    },
    updateLanguage (state, lang) {
      state.language = lang
    },
    updateLoggedInStatus (state, data) {
      state.loggedInStatus = data
    },
    updatePermissions (state, data) {
      state.permissions = data
    },
    updateNavTree (state, data) {
      state.navTree = data
    },
    updateActivePage (state, data) {
      state.activePage = data
    },
    resetState (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    login (context, userInput) {
      Api().post('/login', userInput)
        .then(response => {
          context.commit('updateRoles', response.data.roles)
          context.commit('updateToken', JSON.parse(JSON.stringify(response.data.token)))
          context.commit('updateLoggedInStatus', true)
          Api().get('/accounting/user')
            .then(response => {
              context.commit('updateUser', response.data)
              router.push('home')
            })
            .catch(error => {
              console.log(error)
            })
        })
        .catch(error => {
          return error
        })
    },
    logout ({ commit }) {
      router.push('/')
      commit('resetState')
      /*if (store.getters.loggedInStatus) {
        store.commit('updateLoggedInStatus', false)
        window.localStorage.clear()
        router.push('/')
      }*/
    },
    userHasPermission (context, permission) {
      if (permission.type in context.getters.permissions && permission.action in context.getters.permissions[permission.type]) {
        return typeof context.getters.permissions[permission.type][permission.action].find(x => x.value === permission.scope) !== 'undefined'
      }
      return false
    },
    checkError (context, error) {
      if (error.status === 403) {
        return false
      } else if (error.status === 401) {
        store.dispatch('logout')
      } else return true
    }
  }
})
export default store
